import * as React from 'react';
import { Route, RouteComponentProps } from 'react-router-dom';
import { SystemView } from './system-view';


export function SystemManagementPage(props: RouteComponentProps) {

    return (<>
        <Route exact
            path={props.match.url} component={SystemView}
        />
    </>);
}
